// extracted by mini-css-extract-plugin
export default {"card":"MediaCard_card__HDjO4","cardTitle":"MediaCard_cardTitle__7cA7o","error":"MediaCard_error__TT3yO","notice":"MediaCard_notice__xQToO"};